// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"188":"8aa42334","856":"72d67107"}[chunkId] + ".js";
};